import {Component} from "@angular/core";
import {DocketSelectorSearchModel} from "../docket-selector-search-model.service";
import {DocketSelectorEntityModel} from "../docket-selector-entity-model.service";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-docket-selector-search-page",
    templateUrl: "./docket-selector-search-page.component.html",
    providers: [provideSearchModel(DocketSelectorSearchModel), provideEntityModel(DocketSelectorEntityModel)]
})
export class DocketSelectorSearchPageComponent extends AbstractSearchPage {
    constructor(private searchModel: DocketSelectorSearchModel) {
        super();
    }
}
